import { render, staticRenderFns } from "./GoodsInfoForm.vue?vue&type=template&id=a2efcdae&scoped=true&"
import script from "./GoodsInfoForm.vue?vue&type=script&lang=js&"
export * from "./GoodsInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./GoodsInfoForm.vue?vue&type=style&index=0&id=a2efcdae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2efcdae",
  null
  
)

export default component.exports